import { useEffect } from 'react';
import ChatSidebar from './components/ChatSidebar';
import ChatWindow from './components/ChatWindow';
import { useStore } from './services/chatStore';
import { ThemeProvider } from './context/ThemeContext';

function App() {
  const { activeChat, chats, createChat } = useStore();

  useEffect(() => {
    if (!activeChat && Object.keys(chats).length === 0) {
      createChat('New Chat');
    }
  }, [activeChat, chats, createChat]);

  const currentChat = activeChat ? chats[activeChat] : null;

  return (
    <ThemeProvider>
      <div className="flex h-screen bg-white">
        <ChatSidebar />
        {currentChat && <ChatWindow chatId={currentChat.id} />}
      </div>
    </ThemeProvider>
  );
}

export default App; 